var _style, _g, _g2, _g3, _line, _line2, _g4, _g5, _line3, _line4, _line5, _line6, _line7, _rect, _path, _line8, _g6, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSanofiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 785.43 362.04",
    style: {
      enableBackground: "new 0 0 785.43 362.04"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7A00E6;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{fill:none;stroke:#0000FF;stroke-width:0.2835;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#0000FF;stroke-width:0.2835;stroke-miterlimit:10;stroke-dasharray:5.4826,5.4826,5.4826,5.4826;}\n\t\n\t\t.st5{fill:none;stroke:#0000FF;stroke-width:0.2835;stroke-miterlimit:10;stroke-dasharray:5.4826,5.4826,5.4826,5.4826,5.4826,5.4826;}\n\t.st6{fill:none;stroke:#0000FF;stroke-width:0.2835;stroke-miterlimit:10;stroke-dasharray:5.6917,5.6917,5.6917,5.6917;}\n\t\n\t\t.st7{fill:none;stroke:#0000FF;stroke-width:0.2835;stroke-miterlimit:10;stroke-dasharray:5.6917,5.6917,5.6917,5.6917,5.6917,5.6917;}\n\t.st8{fill:none;stroke:#0000FF;stroke-width:0.2835;stroke-miterlimit:10;stroke-dasharray:6.1123,6.1123,6.1123,6.1123;}\n\t\n\t\t.st9{fill:none;stroke:#0000FF;stroke-width:0.2835;stroke-miterlimit:10;stroke-dasharray:6.1123,6.1123,6.1123,6.1123,6.1123,6.1123;}\n\t.st10{fill:none;stroke:#0000FF;stroke-width:0.2835;stroke-miterlimit:10;stroke-dasharray:5.5821,5.5821,5.5821,5.5821;}\n\t\n\t\t.st11{fill:none;stroke:#0000FF;stroke-width:0.2835;stroke-miterlimit:10;stroke-dasharray:5.5821,5.5821,5.5821,5.5821,5.5821,5.5821;}\n\t\n\t\t.st12{fill:none;stroke:#0000FF;stroke-width:0.2835;stroke-miterlimit:10;stroke-dasharray:5.6282,5.6282,5.6282,5.6282,5.6282,5.6282;}\n\t\n\t\t.st13{fill:none;stroke:#0000FF;stroke-width:0.2835;stroke-miterlimit:10;stroke-dasharray:5.0664,5.0664,5.0664,5.0664,5.0664,5.0664;}\n\t.st14{fill:none;stroke:#0A1E31;stroke-width:0.1766;stroke-miterlimit:10;}\n\t.st15{fill:#0A1E31;}\n\t.st16{display:inline;fill:#FF0000;}\n\t.st17{display:inline;fill:#00FF00;}\n\t.st18{display:inline;fill:#0000FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sanofi_RGB"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M310.2,154.56c-13.6-5.15-26.37-7.62-40.59-7.62c-31.11,0-52.95,20.81-52.95,53.57c0,33.17,18.96,53.57,52.54,53.57 c13.6,0,26.79-2.27,41-8.24c3.3-1.44,5.15-3.71,5.15-8.24V162.8C315.35,158.06,313.49,155.8,310.2,154.56z M288.56,221.94 c0,3.09-1.65,4.53-5.15,5.56c-4.53,1.24-8.45,1.85-14.01,1.85c-13.19,0-25.55-7.83-25.55-28.85c0-21.02,12.36-28.85,25.55-28.85 c5.56,0,9.48,0.62,14.01,1.85c3.5,1.03,5.15,2.47,5.15,5.56V221.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.71,181.35c0-6.31,6.39-10.3,17.31-10.3c10.51,0,20.6,3.5,31.11,9.27c1.03,0.62,2.06,0.82,3.09,0.82 c1.85,0,3.62-1.18,4.53-2.88l6.39-13.6c0.59-1.27,0.82-2.47,0.82-3.5c0-1.65-0.86-3.18-2.47-4.12 c-12.77-7.42-28.02-10.92-42.65-10.92c-27.61,0-45.33,14.84-45.33,37.09c0,43.68,66.35,26.77,66.35,57.07 c0,3.09-0.41,4.94-1.24,7.62c-0.12,0.4-0.21,0.82-0.21,1.24c0,1.65,1.03,2.88,3.09,2.88h18.54c3.09,0,4.33-1.03,5.36-4.12 c1.24-3.5,1.65-8.24,1.65-11.74C203.05,189.38,136.71,200.64,136.71,181.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.05,146.94c-12.16,0-26.37,2.06-41.41,7.42c-2.88,1.03-5.15,3.5-5.15,8.24v85.3c0,2.47,1.65,4.12,4.12,4.12h18.54 c2.47,0,4.12-1.65,4.12-4.12v-69.23c0-3.09,1.65-4.53,4.95-5.36c5.36-1.24,8.86-1.65,15.25-1.65c11.13,0,19.99,5.15,19.99,17.51 v58.72c0,2.47,1.65,4.12,4.12,4.12h18.54c2.47,0,4.12-1.65,4.12-4.12v-62.22C434.23,160.54,418.78,146.94,387.05,146.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.11,146.94c-30.91,0-51.1,22.46-51.1,53.57c0,31.11,20.19,53.57,52.54,53.57c30.91,0,51.1-22.46,51.1-53.57 C557.65,169.4,537.46,146.94,505.11,146.94z M506.56,229.35c-15.25,0-25.34-9.89-25.34-28.85c0-18.96,10.1-28.85,23.9-28.85 c15.25,0,25.34,9.89,25.34,28.85C530.46,219.46,520.36,229.35,506.56,229.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.42,149h-18.54c-2.47,0-4.12,1.65-4.12,4.12v94.78c0,2.47,1.65,4.12,4.12,4.12h18.54c2.47,0,4.12-1.65,4.12-4.12 v-94.78C676.54,150.65,674.89,149,672.42,149z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.86,109.23c-4.12-1.03-8.59-1.44-12.98-1.44c-25.55,0-42.24,13.6-42.24,43.27v96.84c0,2.47,1.65,4.12,4.12,4.12 h18.34c2.47,0,4.12-1.65,4.12-4.12v-76.24h26.17c2.68,0,4.12-1.65,4.12-4.12v-14.22c0-2.68-1.44-4.33-4.12-4.33h-26.17v-2.27 c0-11.33,4.94-17.1,16.28-17.1c4.12,0,8.56,1.03,10.1,1.03c2.47,0,3.5-1.44,3.91-3.91l2.06-10.71c0.18-0.95,0.41-1.79,0.41-2.68 C636.98,111.06,635.74,109.85,632.86,109.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.98,225.65c-8.45,0-14.01,5.36-14.01,14.22c0,8.65,5.56,14.22,14.63,14.22 c8.45,0,14.01-5.56,14.01-14.22C136.61,231,131.04,225.65,121.98,225.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M662.84,107.83c-8.45,0-14.01,5.36-14.01,14.22c0,8.65,5.56,14.22,14.63,14.22 c8.45,0,14.01-5.56,14.01-14.22C677.47,113.18,671.9,107.83,662.84,107.83z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Protection_zone",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "782.6,0 785.43,0 785.43,2.83  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 785.43,
    y1: 8.32,
    x2: 785.43,
    y2: 27.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 785.43,
    y1: 30.25,
    x2: 785.43,
    y2: 356.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "785.43,359.21 785.43,362.04 782.6,362.04  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 776.91,
    y1: 362.04,
    x2: 756.99,
    y2: 362.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 754.14,
    y1: 362.04,
    x2: 5.68,
    y2: 362.04
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "2.83,362.04 0,362.04 0,359.21  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 353.72,
    x2: 0,
    y2: 334.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 331.79,
    x2: 0,
    y2: 5.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "0,2.83 0,0 2.83,0  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 8.53,
    y1: 0,
    x2: 28.45,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 31.29,
    y1: 0,
    x2: 779.75,
    y2: 0
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "674.63,107.83 677.47,107.83 677.47,110.66  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 677.47,
    y1: 116.77,
    x2: 677.47,
    y2: 138.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 677.47,
    y1: 141.22,
    x2: 677.47,
    y2: 248.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "677.47,251.25 677.47,254.08 674.63,254.08  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 669.05,
    y1: 254.08,
    x2: 649.51,
    y2: 254.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 646.72,
    y1: 254.08,
    x2: 113.64,
    y2: 254.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "110.85,254.08 108.01,254.08 108.01,251.25  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 108.01,
    y1: 245.13,
    x2: 108.01,
    y2: 223.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 108.01,
    y1: 220.68,
    x2: 108.01,
    y2: 113.72
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "108.01,110.66 108.01,107.83 110.85,107.83  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 116.43,
    y1: 107.83,
    x2: 135.96,
    y2: 107.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 138.76,
    y1: 107.83,
    x2: 671.84,
    y2: 107.83
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M35.23,199.99c-6.31,0-10.3-6.39-10.3-17.31c0-10.51,3.5-20.6,9.27-31.11c0.62-1.03,0.82-2.06,0.82-3.09 c0-1.85-1.18-3.62-2.88-4.53l-13.6-6.39c-1.27-0.59-2.47-0.82-3.5-0.82c-1.65,0-3.18,0.86-4.12,2.47 C3.5,151.99,0,167.23,0,181.86c0,27.61,14.84,45.33,37.09,45.33c43.68,0,26.77-66.35,57.07-66.35c3.09,0,4.94,0.41,7.62,1.24 c0.4,0.12,0.82,0.21,1.24,0.21c1.65,0,2.88-1.03,2.88-3.09v-18.54c0-3.09-1.03-4.33-4.12-5.36c-3.5-1.24-8.24-1.65-11.74-1.65 C43.27,133.65,54.53,199.99,35.23,199.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M79.53,214.73c0,8.45,5.36,14.01,14.22,14.01c8.65,0,14.22-5.56,14.22-14.63 c0-8.45-5.56-14.01-14.22-14.01C84.89,200.1,79.53,205.66,79.53,214.73z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M750.2,162.39c6.31,0,10.3,6.39,10.3,17.31c0,10.51-3.5,20.6-9.27,31.11c-0.62,1.03-0.82,2.06-0.82,3.09 c0,1.85,1.18,3.62,2.88,4.53l13.6,6.39c1.27,0.59,2.47,0.82,3.5,0.82c1.65,0,3.18-0.86,4.12-2.47 c7.42-12.77,10.92-28.02,10.92-42.65c0-27.61-14.84-45.33-37.09-45.33c-43.68,0-26.77,66.35-57.07,66.35 c-3.09,0-4.94-0.41-7.62-1.24c-0.4-0.12-0.82-0.21-1.24-0.21c-1.65,0-2.88,1.03-2.88,3.09v18.54c0,3.09,1.03,4.33,4.12,5.36 c3.5,1.24,8.24,1.65,11.74,1.65C742.17,228.74,730.91,162.39,750.2,162.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M705.9,147.66c0-8.45-5.36-14.01-14.22-14.01c-8.65,0-14.22,5.56-14.22,14.63 c0,8.45,5.56,14.01,14.22,14.01C700.55,162.29,705.9,156.72,705.9,147.66z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M373.45,35.09c0-6.31,6.39-10.3,17.31-10.3c10.51,0,20.6,3.5,31.11,9.27c1.03,0.62,2.06,0.82,3.09,0.82 c1.85,0,3.62-1.18,4.53-2.88l6.39-13.6c0.59-1.27,0.82-2.47,0.82-3.5c0-1.65-0.86-3.18-2.47-4.12 c-12.77-7.42-28.02-10.92-42.65-10.92c-27.61,0-45.33,14.84-45.33,37.09c0,43.68,66.35,26.77,66.35,57.07 c0,3.09-0.41,4.94-1.24,7.62c-0.12,0.4-0.21,0.82-0.21,1.24c0,1.65,1.03,2.88,3.09,2.88h18.54c3.09,0,4.33-1.03,5.36-4.12 c1.24-3.5,1.65-8.24,1.65-11.74C439.8,43.13,373.45,54.39,373.45,35.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M358.72,79.39c-8.45,0-14.01,5.36-14.01,14.22c0,8.65,5.56,14.22,14.63,14.22 c8.45,0,14.01-5.56,14.01-14.22C373.35,84.75,367.79,79.39,358.72,79.39z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M411.06,326.81c0,6.31-6.39,10.3-17.31,10.3c-10.51,0-20.6-3.5-31.11-9.27c-1.03-0.62-2.06-0.82-3.09-0.82 c-1.85,0-3.62,1.18-4.53,2.88l-6.39,13.6c-0.59,1.27-0.82,2.47-0.82,3.5c0,1.65,0.86,3.18,2.47,4.12 c12.77,7.42,28.02,10.92,42.65,10.92c27.61,0,45.33-14.84,45.33-37.09c0-43.68-66.35-26.77-66.35-57.07 c0-3.09,0.41-4.94,1.24-7.62c0.12-0.4,0.21-0.82,0.21-1.24c0-1.65-1.03-2.88-3.09-2.88h-18.54c-3.09,0-4.33,1.03-5.36,4.12 c-1.24,3.5-1.65,8.24-1.65,11.74C344.71,318.78,411.06,307.52,411.06,326.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M425.79,282.51c8.45,0,14.01-5.36,14.01-14.22c0-8.65-5.56-14.22-14.63-14.22 c-8.45,0-14.01,5.56-14.01,14.22C411.16,277.16,416.72,282.51,425.79,282.51z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Info_FUB",
    className: "st1"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 408.3362 542.6354)",
    style: {
      display: "inline",
      fill: "#1A1A18",
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4173px"
    }
  }, "R122 G0 B230"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 408.3362 564.5444)",
    style: {
      display: "inline",
      fill: "#1A1A18",
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4173px"
    }
  }, "R0 G0 B0"), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.39,
    y: 532.79,
    className: "st0",
    width: 12.92,
    height: 12.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.39,
    y: 554.7,
    width: 12.92,
    height: 12.92
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 611.49,
    y1: 618.9,
    x2: 611.49,
    y2: 662.18
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 695.61,
    y1: 618.9,
    x2: 695.61,
    y2: 662.18
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 531.4406 626.3367)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "7.6511px"
    }
  }, "Designer"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 616.8938 626.3367)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "7.6511px"
    }
  }, "Project Manager"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 701.0092 626.3367)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "7.6511px"
    }
  }, "Production Manager"), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 521.79,
    y: 592.84,
    className: "st15",
    width: 263.64,
    height: 20.17
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M785.25,593.01v79.38H521.97v-79.38H785.25 M785.43,592.84H521.79v79.74h263.64V592.84L785.43,592.84z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 607.1185 606.3574)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "7.6511px"
    }
  }, "VALIDATION // APPROVAL"), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 44.26,
    y1: 464.9,
    x2: 44.26,
    y2: 576.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 175.58,
    y1: 464.9,
    x2: 175.58,
    y2: 576.75
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 356.86,
    y1: 490.79,
    x2: 356.86,
    y2: 576.75
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 630.31,
    y1: 490.79,
    x2: 630.31,
    y2: 576.75
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 160.4,
    y1: 520.82,
    x2: 55.62,
    y2: 520.82
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 592.84,
    className: "st15",
    width: 521.79,
    height: 79.74
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 193.7335 574.2435)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Color profil "), /*#__PURE__*/React.createElement("tspan", {
    x: 52.02,
    y: 0,
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, ": "), /*#__PURE__*/React.createElement("tspan", {
    x: 56.54,
    y: 0,
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "sRGB IEC61966-2.1")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 193.7335 515.0175)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Dimensions "), /*#__PURE__*/React.createElement("tspan", {
    x: 52.02,
    y: 0,
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, ": -")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 193.7335 476.2366)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "File Name "), /*#__PURE__*/React.createElement("tspan", {
    x: 44.55,
    y: 0,
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, ": 211125_SANOFI_LOGO_RGB.ai")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 55.9673 574.2435)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Artworker : CS/DC"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 55.9673 555.8296)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Designer : MG"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 193.7335 534.4079)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Version no : "), /*#__PURE__*/React.createElement("tspan", {
    x: 53.02,
    y: 0,
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Bold'",
      fontSize: "9.4168px"
    }
  }, "2")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 55.9673 537.4167)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Project Manager : JF"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 55.9668 513.0624)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Date : 25/11/2021"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 193.734 495.6271)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Printing process : -"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 373.8674 495.6271)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Colors :"), /*#__PURE__*/React.createElement("rect", {
    x: 17.06,
    y: 604.27,
    style: {
      fill: "none"
    },
    width: 491.41,
    height: 57.92
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 17.0136 610.8134)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Bold'",
      fontSize: "9.4168px"
    }
  }, "WARNING ! This is not an artwork file ready to print."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "Spot"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.23,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 19.98,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "colors"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.98,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 45.72,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "are"), /*#__PURE__*/React.createElement("tspan", {
    x: 58.36,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 60.11,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "integrated"), /*#__PURE__*/React.createElement("tspan", {
    x: 100.67,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 102.41,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "in"), /*#__PURE__*/React.createElement("tspan", {
    x: 109.05,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 110.8,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "vector"), /*#__PURE__*/React.createElement("tspan", {
    x: 135.98,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 137.73,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "elements."), /*#__PURE__*/React.createElement("tspan", {
    x: 175.05,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 176.8,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "Digital"), /*#__PURE__*/React.createElement("tspan", {
    x: 200.76,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 202.51,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "color"), /*#__PURE__*/React.createElement("tspan", {
    x: 222.4,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 224.15,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "separation,"), /*#__PURE__*/React.createElement("tspan", {
    x: 267.24,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 268.99,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "overprinting"), /*#__PURE__*/React.createElement("tspan", {
    x: 315.86,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 317.61,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "and"), /*#__PURE__*/React.createElement("tspan", {
    x: 331.53,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 333.28,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "trappings"), /*#__PURE__*/React.createElement("tspan", {
    x: 369.69,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 371.44,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "have"), /*#__PURE__*/React.createElement("tspan", {
    x: 389.41,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 391.16,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "to"), /*#__PURE__*/React.createElement("tspan", {
    x: 399.53,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 401.27,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "be"), /*#__PURE__*/React.createElement("tspan", {
    x: 410.94,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 412.69,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "handled"), /*#__PURE__*/React.createElement("tspan", {
    x: 442.99,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 444.74,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "by"), /*#__PURE__*/React.createElement("tspan", {
    x: 453.5,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 455.25,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "the"), /*#__PURE__*/React.createElement("tspan", {
    x: 468.25,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 470,
    y: 15.3,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "repro "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24.72,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "house following our color recommendations. This digital proof sent along with this file (Epson 7900) is the reference color target. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "Client"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.72,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 24.62,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "is"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.68,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 32.59,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "responsible"), /*#__PURE__*/React.createElement("tspan", {
    x: 77.08,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 78.98,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "for"), /*#__PURE__*/React.createElement("tspan", {
    x: 90.39,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 92.29,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "proofreading"), /*#__PURE__*/React.createElement("tspan", {
    x: 142.41,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 144.31,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "all"), /*#__PURE__*/React.createElement("tspan", {
    x: 152.64,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 154.54,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "copy"), /*#__PURE__*/React.createElement("tspan", {
    x: 172.88,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 174.78,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "before"), /*#__PURE__*/React.createElement("tspan", {
    x: 200.69,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 202.59,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "artwork\u2019s"), /*#__PURE__*/React.createElement("tspan", {
    x: 238.49,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 240.39,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "delivery."), /*#__PURE__*/React.createElement("tspan", {
    x: 272.22,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 274.12,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Bold'",
      fontSize: "8.2397px"
    }
  }, "FutureBrand"), /*#__PURE__*/React.createElement("tspan", {
    x: 322.25,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 324.15,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "won\u2019t"), /*#__PURE__*/React.createElement("tspan", {
    x: 345.19,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 347.1,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "accept"), /*#__PURE__*/React.createElement("tspan", {
    x: 373.8,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 375.7,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "any"), /*#__PURE__*/React.createElement("tspan", {
    x: 388.72,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 390.62,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "responsability"), /*#__PURE__*/React.createElement("tspan", {
    x: 443.98,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 445.89,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "for"), /*#__PURE__*/React.createElement("tspan", {
    x: 457.3,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 459.2,
    y: 40.02,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "changes "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 49.44,
    style: {
      fill: "#FFFFFF",
      fontFamily: "'RelativePro-Book'",
      fontSize: "8.2397px"
    }
  }, "made to this artwork after delivery.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M25.69,468.65c0-0.78,0.29-1.39,0.87-1.85c0.58-0.45,1.31-0.68,2.2-0.68s1.62,0.23,2.2,0.68 c0.58,0.45,0.87,1.07,0.87,1.85c0,0.78-0.29,1.39-0.87,1.85c-0.58,0.45-1.31,0.68-2.2,0.68c-0.88,0-1.62-0.23-2.2-0.68 C25.98,470.04,25.69,469.42,25.69,468.65 M33.99,469.13c0-1.08-0.34-2.05-1.02-2.89h0.63c0.13,0,0.2-0.07,0.2-0.2v-2.02 c0-0.13-0.07-0.2-0.2-0.2H19.95c-0.14,0-0.21,0.07-0.21,0.2v2.02c0.01,0.13,0.08,0.2,0.21,0.2h4.57c-0.67,0.84-1,1.81-1,2.89 c0,1.37,0.47,2.47,1.41,3.31c0.94,0.84,2.22,1.26,3.83,1.26c1.61,0,2.88-0.42,3.83-1.26C33.52,471.6,33.99,470.49,33.99,469.13  M25.69,490.7c0-0.78,0.29-1.39,0.87-1.85c0.58-0.45,1.31-0.68,2.2-0.68s1.62,0.23,2.2,0.68c0.58,0.45,0.87,1.07,0.87,1.85 c0,0.78-0.29,1.39-0.87,1.85c-0.58,0.45-1.31,0.68-2.2,0.68s-1.62-0.23-2.2-0.68C25.98,492.09,25.69,491.47,25.69,490.7  M33.99,491.18c0-1.08-0.34-2.05-1.02-2.89h0.63c0.13,0,0.2-0.07,0.2-0.2v-2.02c0-0.13-0.07-0.2-0.2-0.2h-9.68 c-0.14,0-0.21,0.07-0.21,0.2v2.02c0.01,0.13,0.08,0.2,0.21,0.2h0.6c-0.67,0.84-1,1.81-1,2.89c0,1.37,0.47,2.47,1.41,3.31 c0.94,0.84,2.22,1.26,3.83,1.26c1.61,0,2.88-0.42,3.83-1.26C33.52,493.64,33.99,492.54,33.99,491.18 M33.82,575.38v-2.13 c0-0.13-0.07-0.2-0.2-0.2H27.9l0-5.7c-0.01-0.13-0.07-0.2-0.21-0.2h-1.92c-0.14,0-0.21,0.07-0.21,0.2l0,5.7H22.1v-5.94 c-0.01-0.14-0.07-0.21-0.21-0.21h-1.92c-0.14,0.01-0.21,0.08-0.21,0.21l0,8.26c0.01,0.14,0.08,0.21,0.21,0.21h13.65 C33.76,575.59,33.82,575.52,33.82,575.38 M25.89,554.77l0-1.72h4.73c1.08,0,1.92-0.31,2.5-0.93c0.58-0.62,0.87-1.43,0.87-2.44 c0.01-0.98-0.1-1.75-0.31-2.31c-0.04-0.1-0.15-0.16-0.34-0.16h-1.65c-0.12,0-0.18,0.05-0.18,0.14c0,0.05,0.01,0.1,0.02,0.14 c0.2,0.54,0.29,1.13,0.29,1.77c0,0.49-0.13,0.84-0.4,1.06c-0.27,0.22-0.68,0.32-1.24,0.32h-4.29v-3.03c0-0.14-0.07-0.21-0.2-0.21 h-1.77c-0.13,0.01-0.2,0.07-0.2,0.21v3.03h-2.89c-0.13,0-0.2,0.07-0.2,0.2l0,2.01c0,0.14,0.07,0.21,0.2,0.21h2.89v1.72 c0,0.13,0.07,0.2,0.2,0.2h1.77C25.83,554.96,25.89,554.9,25.89,554.77 M22.1,512.84l0-3.08c0-0.48,0.13-0.87,0.39-1.17 c0.26-0.3,0.65-0.46,1.17-0.46c0.52,0,0.92,0.15,1.19,0.45c0.27,0.3,0.41,0.69,0.41,1.18v3.08H22.1z M27.6,512.84l0-3.29 c0-0.57,0.18-1.05,0.53-1.42c0.36-0.37,0.83-0.55,1.42-0.55c0.61,0,1.09,0.18,1.43,0.54c0.34,0.36,0.51,0.84,0.51,1.43v3.29H27.6z  M33.82,515.16v-5.86c0-1.3-0.4-2.34-1.19-3.12c-0.79-0.78-1.79-1.17-2.99-1.17c-1.66,0-2.79,0.68-3.4,2.03 c-0.75-0.95-1.67-1.43-2.77-1.43c-1.12,0-2.02,0.4-2.7,1.2c-0.67,0.8-1.01,1.79-1.01,2.98l0,5.38c0.01,0.14,0.08,0.21,0.21,0.21 h13.65C33.76,515.36,33.82,515.29,33.82,515.16 M33.82,503.35v-2c0-0.14-0.07-0.21-0.2-0.21h-5.21c-0.99,0-1.69-0.19-2.09-0.57 c-0.41-0.38-0.61-0.92-0.61-1.61c0-0.61,0.19-1.3,0.56-2.07c0.03-0.07,0.04-0.11,0.04-0.14c0.01-0.11-0.06-0.17-0.21-0.17h-1.87 c-0.18,0-0.3,0.08-0.36,0.25c-0.22,0.61-0.32,1.23-0.32,1.84c0.01,0.98,0.32,1.8,0.95,2.47h-0.55c-0.13,0.01-0.2,0.08-0.2,0.21v2 c0,0.14,0.07,0.21,0.2,0.21h9.68C33.76,503.56,33.82,503.49,33.82,503.35 M33.08,544.77c0.61-0.62,0.91-1.48,0.91-2.58 c0.01-1.11-0.37-2.12-1.12-3.03h0.73c0.13-0.01,0.2-0.08,0.2-0.21l0-2.01c0-0.13-0.07-0.2-0.2-0.2h-9.68c-0.13,0-0.2,0.07-0.2,0.2 l0,2.01c0,0.14,0.07,0.21,0.2,0.21h4.56c1.12,0,1.96,0.23,2.52,0.68c0.56,0.45,0.83,1.03,0.83,1.72c0,1.15-0.7,1.72-2.09,1.72 h-5.82c-0.13,0.01-0.2,0.07-0.2,0.21v2.01c0,0.13,0.07,0.2,0.2,0.2h6.68C31.65,545.7,32.48,545.39,33.08,544.77 M33.82,534.75v-2 c0-0.14-0.07-0.21-0.2-0.21h-5.21c-0.99,0-1.69-0.19-2.09-0.57c-0.41-0.38-0.61-0.92-0.61-1.61c0-0.61,0.19-1.3,0.56-2.07 c0.03-0.07,0.04-0.11,0.04-0.14c0.01-0.11-0.06-0.17-0.21-0.17h-1.87c-0.18,0-0.3,0.08-0.36,0.25c-0.22,0.61-0.32,1.23-0.32,1.84 c0.01,0.98,0.32,1.8,0.95,2.47h-0.55c-0.13,0.01-0.2,0.08-0.2,0.21v2c0,0.14,0.07,0.21,0.2,0.21h9.68 C33.76,534.96,33.82,534.89,33.82,534.75 M33.08,564.54c0.61-0.62,0.91-1.48,0.91-2.58c0.01-1.11-0.37-2.12-1.12-3.03h0.73 c0.13-0.01,0.2-0.08,0.2-0.21v-2.01c0-0.13-0.07-0.2-0.2-0.2h-9.68c-0.13,0-0.2,0.07-0.2,0.2v2.01c0,0.14,0.07,0.21,0.2,0.21h4.56 c1.12,0,1.96,0.23,2.52,0.68c0.56,0.45,0.83,1.03,0.83,1.72c0,1.15-0.7,1.72-2.09,1.72h-5.82c-0.13,0.01-0.2,0.07-0.2,0.21l0,2.01 c0,0.13,0.07,0.2,0.2,0.2h6.68C31.65,565.47,32.48,565.16,33.08,564.54 M33.82,483.92l0-2c0-0.14-0.07-0.21-0.2-0.21h-4.56 c-1.12,0-1.97-0.23-2.52-0.69c-0.56-0.46-0.83-1.03-0.83-1.72c0-1.15,0.7-1.72,2.09-1.72h5.83c0.13,0,0.2-0.07,0.2-0.2v-2.01 c0-0.14-0.07-0.21-0.2-0.21h-6.68c-1.05,0-1.87,0.31-2.48,0.94c-0.61,0.62-0.92,1.48-0.92,2.58c0,1.11,0.37,2.12,1.12,3.03h-0.72 c-0.13,0.01-0.2,0.08-0.2,0.21l0,2c0,0.14,0.07,0.21,0.2,0.21h9.68C33.76,484.13,33.82,484.06,33.82,483.92 M26.18,523.6 c-0.33-0.47-0.49-0.99-0.49-1.56c0-1.36,0.61-2.24,1.83-2.64l0,5.2C26.95,524.4,26.51,524.07,26.18,523.6 M32.53,525.73 c0.97-0.98,1.46-2.21,1.46-3.68c0.01-2.25-0.92-3.82-2.77-4.71c-0.07-0.03-0.13-0.06-0.2-0.09h0c-0.06-0.02-0.09,0-0.12,0.03 c-0.02,0.02-0.02,0.07-0.02,0.11v2.21c0,0.18,0.08,0.23,0.18,0.34c0.51,0.5,0.76,1.2,0.76,2.1c0,0.72-0.21,1.31-0.63,1.78 c-0.42,0.47-0.98,0.76-1.67,0.86l0-7.64c-0.01-0.14-0.07-0.21-0.21-0.21h-0.34c-1.52,0-2.81,0.47-3.87,1.41 c-1.06,0.94-1.59,2.2-1.59,3.8c0,1.44,0.49,2.67,1.48,3.67c0.99,1,2.24,1.5,3.76,1.5C30.3,527.21,31.56,526.72,32.53,525.73"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 193.734 554.8521)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Software "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 236.4289 554.8521)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, ": "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 240.9489 554.8521)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Illustrator"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.583 0 0 0.583 281.4392 551.7164)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "\xAE "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 286.7643 554.8521)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "CC 2020"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 647.5244 495.6271)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Font list : "), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 521.91,
    y1: 592.84,
    x2: 521.91,
    y2: 672.57
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 55.9668 494.6486)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Job number : SN0002"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 55.9673 476.2366)",
    className: "st15",
    style: {
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.4168px"
    }
  }, "Client : SANOFI"), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M785.25,447.26v145.4H0.18v-145.4H785.25 M785.43,447.08H0v145.76h785.43V447.08L785.43,447.08z"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 388.39,
    y: 510.88,
    className: "st16",
    width: 4.31,
    height: 12.92
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 392.7,
    y: 510.88,
    className: "st17",
    width: 4.31,
    height: 12.92
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 397.01,
    y: 510.88,
    className: "st18",
    width: 4.31,
    height: 12.92
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 408.3359 520.7264)",
    style: {
      display: "inline",
      fill: "#1A1A18",
      fontFamily: "'RelativePro-Book'",
      fontSize: "9.417px"
    }
  }, "RGB")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanofiLogo);
export default __webpack_public_path__ + "static/media/sanofi-logo.75d84ce89d7c65fcd8658c14cd43d185.svg";
export { ForwardRef as ReactComponent };